export default __webpack_public_path__ + "static/media/ruby-flat.5df30571.svg";